import { render } from "./bite_post_button.vue?vue&type=template&id=5196583d"
import script from "./bite_post_button.js?vue&type=script&lang=js&external"
export * from "./bite_post_button.js?vue&type=script&lang=js&external"

import "./bite_post_button.vue?vue&type=style&index=0&id=5196583d&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__